import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import copy from 'copy-to-clipboard'

import Modal from '../../../../../common/components/Modal/Modal.jsx'
import Header from '../../../../../common/components/Modal/components/Header/Header.jsx'
import Toast from '../../../../../common/components/Toast/Toast'

import EmbedCodeTab from './views/EmbedCodeTab.jsx'
import ShareProjectMainTab from './views/ShareProjectMainTab.jsx'
import { SHARE_MODAL_TABS } from './utils/constants.js'

import './ShareProjectModal.scss'

const ShareProjectModal = ({ title, onClose, data, isPublished, t }) => {
    const [tab, setTab] = useState(SHARE_MODAL_TABS.main)

    const headerClasses = isPublished ? ['share-project-header-published'] : []

    return (
        <Modal closeOnOverlayClick={false} closeOnEsc={false}>
            <div className="share-project-modal">
                {tab === SHARE_MODAL_TABS.main && (
                    <>
                        <Header title={title} onClose={onClose} classes={headerClasses} />
                        <ShareProjectMainTab
                            projectUrl={data.projectUrl}
                            t={t}
                            setTab={setTab}
                        />
                    </>
                )}
                {tab === SHARE_MODAL_TABS.embedCode && (
                    <>
                        <Header
                            title={
                                <div className="share-project-modal__header">
                                    <div
                                        className="share-project-modal__header-back-btn"
                                        onClick={() => setTab(SHARE_MODAL_TABS.main)}
                                    >
                                        {t('_components._modal._share_project.back_to_options')}
                                    </div>
                                    {t('Install embed code')}
                                </div>
                            }
                            onClose={onClose}
                        />
                        <EmbedCodeTab embedCode={data.embedCode} iframeCode={data.iframeCode} t={t} />
                    </>
                )}
            </div>
        </Modal>
    )
}

export default withTranslation('translations')(ShareProjectModal)
